import React from "react";

function SubHeader({
  title,
  description,
  children,
  containerClass = "container-xxl",
  icon,
  iconClass = "text-primary",
}) {
  return (
    <div className="py-3 py-lg-4 border-bottom bg-light">
      <div
        className={`${containerClass} d-flex justify-content-between flex-md-row flex-column align-items-md-center gap-3`}
      >
        <div className="d-flex align-items-center flex-wrap me-3">
          {icon && (
            <span
              className={`d-inline-flex align-items-center justify-content-center rounded-3 me-3 flex-shrink-0 bg-opacity-10 ${iconClass.replace("text-", "bg-")} ${iconClass}`}
              style={{ width: "2.75rem", height: "2.75rem" }}
              aria-hidden="true"
            >
              <i className={`bi ${icon} fs-4`} />
            </span>
          )}
          <div className="d-flex flex-column justify-content-center">
            <h1 className="h3 text-dark fw-bold my-0">{title && title}</h1>
            {description && (
              <span className="text-muted fw-medium small my-0 pt-1">
                {description}
              </span>
            )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export default SubHeader;
